import React, { Component } from 'react';
import { connect } from 'react-redux'
import { submit } from 'redux-form'
import { Utils } from '../../services/';
import { withTranslation } from 'react-i18next';

import './DaysField.css';

class DaysField extends Component<{}> {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
    }

    toggle(index) {
        const { input, disabled, locked, allowedDays } = this.props;
        if (disabled || locked) {
            return;
        }
        if (Array.isArray(allowedDays) && allowedDays.length > 0 && allowedDays.indexOf(index) === -1) {
            return;
        }

        const days = Array.isArray(this.props.days) ? [...this.props.days] : [];
        const at = days.indexOf(index);
        if (at !== -1) {
            days.splice(at, 1);
        } else {
            days.push(index);
        }
        input.onChange(days);
        this.setState({});
    }

    render() {
        const { t, days, meta, disabled, locked, allowedDays } = this.props;
        const selected = Array.isArray(days) ? days : [];
        const days_error = meta?.error ? t(meta.error) : undefined;
        const choices = Array.isArray(allowedDays) && allowedDays.length > 0
            ? Utils.days().filter((day) => allowedDays.indexOf(day.index) !== -1)
            : Utils.days();
        const is_locked = !!locked || !!disabled;

        return (
            <div className={`DaysField${days_error ? ' is-invalid' : ''}${is_locked ? ' is-disabled' : ''}`}>
                <div className="day-choices">
                    { choices.map((day) => (
                        <span
                            key={day.index}
                            onClick={(_e) => { this.toggle(day.index) }}
                            className={"day-choice" + (selected.indexOf(day.index) !== -1 ? " active" : "")}
                        >
                            <span className="day">
                                { t('common.' + day.label) }
                            </span>
                        </span>
                    ))}
                </div>
                {days_error && (
                    <div className="alert alert-danger alert-inline mt-1 mb-0 py-2 px-3 small" role="alert">
                        <span className="alert-inline-body">{days_error}</span>
                    </div>
                )}
            </div>
        );
    }
}

const mapDispatchToProps = {
    dispatchSubmitForm: (form) => submit(form)
}
const mapStateToProps = _state => ({})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation("translations")(DaysField))
